import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exporting from 'highcharts/modules/exporting';

// Initialize exporting module
exporting(Highcharts);

const TaskCompletionRateBar = () => {
  // Example data
  const careNavigators = ['1', '2', '3', '4', '5'];
  const tasksCompleted = [25, 40, 35, 50, 55]; // Example data for tasks completed
  const totalAssignedTasks = [30, 45, 40, 55, 60]; // Example data for total assigned tasks

  // Calculate completion rates
  const completionRates = tasksCompleted.map((completed, index) => {
    return (completed / totalAssignedTasks[index]) * 100;
  });

  const yAxisJson = {
    title: {
      text: null
    }
  };

  const tooltipJson = {
    shared: true,
    valueSuffix: ' %'
  };

  const columnData = [{
    name: 'Task Completion Rate',
    data: completionRates,
    color: '#1279be'
  }];

  const optionsCN7 = {
    chart: {
      type: 'column',
      height: 220,
      spacing: [0, 0, 0, 0],
      options3d: {
        enabled: true,
        alpha: 0,
        beta: 15,
        depth: 50,
        viewDistance: 25 // Adjusted viewDistance for better 3D effect
      }
    },
    title: {
      text: null,
      align: 'left',
      style: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#333',
        fontFamily: "IBM Plex Sans, sans-serif"
      }
    },
    xAxis: {
      categories: careNavigators,
      gridLineWidth: 0
    },
    yAxis: yAxisJson,
    tooltip: tooltipJson,
    plotOptions: {
      column: {
        borderRadius: 5, // Set border radius for columns
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          format: '{point.y:.1f} %', // Format data labels to show percentage
          style: {
            textOutline: 'none'
          }
        }
      }
    },
    series: columnData,
    credits: {
      enabled: false
    },
    exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              enabled: false
            }
          }
        },
    legend: {
      enabled: true
    }
  };

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={optionsCN7}
      />
    </div>
  );
};

export default TaskCompletionRateBar;
